import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { AppUpdateVersionService } from '@core/services/app-update-version/app-update-version.service';

@Component({
  standalone: true,
  imports: [
    CommonModule, 
    NzSpaceModule, 
    NzTypographyModule,
    NzProgressModule
  ],
  template: `
    <nz-space
      nzDirection="vertical"
      nzSize="middle"
      nzAlign="center"
      class="w-100 text-center">
      
      <p *nzSpaceItem nz-typography>{{ updateService.getUpdateMessage() }}</p>
      
      <div *nzSpaceItem class="w-100">
        <nz-progress
          [nzPercent]="(updateService.updateProgressPercent$ | async) ?? 0"
          [nzStatus]="((updateService.updateProgressPercent$ | async) ?? 0) >= 100 ? 'success' : 'active'"
          nzType="circle"
          [nzWidth]="80"
          [nzShowInfo]="false"
          [nzStrokeWidth]="12">
        </nz-progress>
      </div>
      
      <p *nzSpaceItem nz-typography class="mb-0">
        {{ ((updateService.updateProgressPercent$ | async) ?? 0) | number: '1.0-0' }}%
      </p>
    </nz-space>
  `,
})
export class AppUpdateOverlayContentComponent {
  constructor(readonly updateService: AppUpdateVersionService) {}
}